<script>

import {Maps} from "tortilla";

export default {
  props: [
    'regions',
    'apiKey',
    'loanOfficers'
  ],
  created: function() {
    this.$gmaps().then( ( gm ) => {
      events.$on('map-intialized', ( map ) => {
        this.setMapInstance(map);
        this.gm = gm;
        this.updateCommunityMap(this.selectedCommunity);
      });
    });

    this.setRegion(this.regions[0]);
    this.setCommunity(this.regions[0].communities[0]);
  },
  data: function() {
    return {
      selectedRegion: {},
      selectedCommunity: {},
      markers: []
    }
  },
  computed: {
    selectedCommunityLogo: function() {
      if (!this.selectedCommunity) return [];
      if (!this.selectedCommunity.images) return [];
      if (!this.selectedCommunity.images.logo) return [];
      return this.selectedCommunity.images.logo;
    },

    selectedCommunityDirectionsLink: function() {
      return this.directions(this.selectedCommunity);
    }
  },
  methods: {
    directions: function({address, city, state, zip}) {
      return `https://maps.google.com/maps?daddr=${address} ${city} ${state} ${zip}`;
    },
    mapCenter({address, city, state, zip}) {
      return `${address} ${city} ${state} ${zip}`;
    },
    setRegion: function(region) {
      this.selectedRegion = region;
    },
    setCommunity: function(community) {
      this.selectedCommunity = community;
    },
    setMapInstance: function(map) {
      this.mapInstance = map;
    },
    setMarkers: function(markers) {
      this.markers = markers;
    },
    getLoanOfficerIds: function() {
      var ids = [];
      if (!this.regions) return;
      this.regions.map((region) => {
        if (typeof this.selectedRegion != 'undefined' && this.selectedRegion.id && this.selectedRegion.id != region.id) {
          return false;
        }
        region.communities.map((community) => {
          if (typeof this.selectedCommunity != 'undefined' && this.selectedCommunity.id && this.selectedCommunity.id != community.id) {
          return false;
        }
          ids.push(community.loan_officer_id);
        })
      });

      ids = ids
        .filter(function(a) {
          return a;
        })
        .filter(function onlyUnique(value, index, self) {
          return self.indexOf(value) === index;
        })
      ;

       return ids;
    },

    updateCommunityMap: function(is) {

      const icon = {
        url: "http://discovery-staging.graphiclanguage.net/images/site/maps/community-pin.svg",
        scaledSize: new this.gm.Size(30, 30)
      };

      const position = new this.gm.LatLng(
        is.latitude,
        is.longitude
      );

      const marker = new this.gm.Marker({
        icon: icon,
        position: position,
        optimized: false
      });


      this.setMarkers([marker]);
    },

    tel: function (tel) {
      return `tel:${tel}`;
    },

    mailto: function (mailto) {
      return `mailto:${mailto}`;
    }
  },
  watch: {
    selectedRegion: function(is) {
      if (!is) return;
      this.setCommunity(is.communities[0]);
    },
    selectedCommunity: function(is) {
      if (!is || typeof is == 'undefined') return;
      if (!this.gm || typeof this.gm == 'undefined') return;
      this.updateCommunityMap(is);
    }
  }
}

</script>



// WEBPACK FOOTER //
// resources/components/apps/contact-selector.vue